import { render, staticRenderFns } from "./articleCard.vue?vue&type=template&id=2fb80576&scoped=true&"
import script from "./articleCard.vue?vue&type=script&lang=js&"
export * from "./articleCard.vue?vue&type=script&lang=js&"
import style0 from "./articleCard.vue?vue&type=style&index=0&id=2fb80576&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb80576",
  null
  
)

export default component.exports